import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// asset_categories — หมวดสินทรัพย์ (Asset Category)
// ============================================================================
export const assetCategories = sqliteTable("accounting_asset_categories", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  depreciationMethod: text("depreciation_method").notNull().default("straight_line"), // straight_line, declining_balance, double_declining
  usefulLifeYears: integer("useful_life_years").notNull().default(5),
  depreciationRate: real("depreciation_rate").notNull().default(20), // % per year
  assetAccountId: text("asset_account_id"),
  depreciationAccountId: text("depreciation_account_id"),
  accumulatedDepreciationAccountId: text("accumulated_depreciation_account_id"),
  isActive: integer("is_active").notNull().default(1),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  ac_company_idx: index("ac_company_idx").on(table.companyId, table.isActive),
}));

export type AssetCategory = typeof assetCategories.$inferSelect;
export type NewAssetCategory = typeof assetCategories.$inferInsert;
